<template>
  <div>
    <panel>
      <div slot="toolbar">
        <w-button class="btn-light float-right mr-2" text="Wybierz filtry" @click="openFiltersModal" />
      </div>

      <w-table
        :data="data"
        :columns="columns"
        :total="-1"
        :hide-search-input="true"
        :hide-add-button="true"
        :per-page="-1"
      />

      <post-form class="float-right mt-4" text="Pobierz CSV" :fields="csvFields" :url="csvUrl" />
    </panel>

    <filters-modal
      title="Wybierz filtry"
      class="modal-big"
      :filters="filters"
      :show="showFiltersModal"
      @close="closeFiltersModal"
      @save="saveFilters"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import PostForm from '@/components/postForm/PostForm';
import WTable from '@/components/table/Table';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { reportFiltersMixin } from '@/mixins/reportFilters';
import { config } from '@/utils/config';
import { getReportFilters, getStatistics } from '@/utils/report';

// @vuese
// Statystyki
export default {
  components: { Panel, PostForm, WTable },

  mixins: [reportFiltersMixin],

  data() {
    return { csvUrl: config.csvURL + '/statistics/' + this.$route.params.procedureId };
  },

  computed: {
    ...mapState({
      data: state => state.statistics.procedure,

      columns: state =>
        state.setting.settings[PublicSettings.STATISTICS_COLUMNS] &&
        JSON.parse(state.setting.settings[PublicSettings.STATISTICS_COLUMNS].value)
    }),

    csvFields() {
      this.filters; // pola nie odświeżą się po zmianie filtrów bez tego
      return [{ name: 'filters', value: { filterFields: getReportFilters(this.$route) } }];
    }
  },

  methods: {
    // @vuese
    // Aktualizuje statystyki
    updateList() {
      return getStatistics(this.$route);
    }
  }
};
</script>
